import { render } from "./Organization.vue?vue&type=template&id=dde72eaa"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_c888307087c990cfda5c0d18ef320e2e/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/icons/Organization.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dde72eaa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dde72eaa', __exports__)) {
    api.reload('dde72eaa', __exports__)
  }
  
  module.hot.accept("./Organization.vue?vue&type=template&id=dde72eaa", () => {
    api.rerender('dde72eaa', render)
  })

}


export default __exports__